import { useLang } from '@/app/utils/useLang';
import { getSolarRecommand2 } from '@/service/solar-calculator';
import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';

interface IProductItem {
    title: string;
    desc: string;
    params: string[];
    img: string;
    price: string;
    discountPrice: string;
    skuTitle: string;
    quantity: number;
    variantId: string;
}

export default function useProduct(locale: string, statusB: boolean) {
    const { t } = useLang('ProductList');

    const variantIds = {
        us: ['54553979682889', '54553980141641', '54553980043337'],
        ca: ['52734893490547', '52734893556083', '52734893523315'],
        eu: ['51564168347991', '51564168413527', '51564168380759'],
        uk: ['51728609870163', '51728609935699', '51728609902931'],
        de: ['56791585128829', '56791585194365', '56791585161597'],
        fr: ['51242023518555', '51242023584091', '51242023551323'],
        it: ['55260319744376', '55260319809912', '55260319777144'],
        es: ['51242023977307', '51242024042843', '51242024010075'],
        nl: ['51820095340820', '51820095406356', '51820095373588'],
        ph: ['52748141363510', '', '52748141396278'],
    };
    const imgMap = [
        'https://websiteoss.ecoflow.com/upload/image/1757468707409/6_1%20IMG.png', // trail 200
        'https://websiteoss.ecoflow.com/upload/image/1757468707172/6_2%20IMG.png', // trail 300 plus
        'https://websiteoss.ecoflow.com/upload/image/1757468707139/6_3%20IMG.png', // trial 300
    ];

    const productFn = (locale: keyof typeof variantIds = 'us') => {
        return variantIds[locale].map((item, index) => {
            return {
                skuTitle: t(`item${index + 1}_title`),
                desc: t(`item${index + 1}_desc`),
                params: [t(`item${index + 1}_pasams_desc1`), t(`item${index + 1}_pasams_desc2`), t(`item${index + 1}_pasams_desc3`)],
                variantId: item,
                img: imgMap[index],
            };
        });
    };

    // @ts-expect-error
    const [productList, setProductList] = useState<IProductItem[]>(productFn(locale as keyof typeof variantIds));

    useEffect(() => {
        if (!statusB) {
            return;
        }
        getItemInfo();
    }, [statusB]);

    async function getItemInfo() {
        const variantIds = productList.map((item) => item.variantId);
        const res = await getSolarRecommand2({ variantIds }, locale);
        if (res.code === '0') {
            const newItems = cloneDeep(productList);
            res.data.forEach((item: any) => {
                const newItem = newItems.find((_item) => _item.variantId === item.variantId);
                if (newItem) {
                    newItem.img = item.variantImg;
                    newItem.price = item.price;
                    newItem.discountPrice = item.compareAtPrice;
                    newItem.skuTitle = item.skuTitle;
                    newItem.quantity = item?.inventoryPolicy === 'continue' && item?.inventoryQuantity <= 0 ? 100 : item.inventoryQuantity;
                }
            });

            setProductList(newItems);
        }
    }

    return {
        productList,
    };
}
